module.exports = __webpack_public_path__ + "static/media/luminous-BG_centr-horisontal.9da3f7d8.svg";